import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import '@/plugins/socket.js'
import store from './store'
import './plugins/element.js'
import './plugins/svgicon.js'

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
